import l from "./FadingCircle.vue2.js";
import { openBlock as i, createElementBlock as n, normalizeStyle as o, normalizeClass as c, Fragment as t, renderList as s, createElementVNode as a } from "vue";
/* empty css                  */
import p from "../../../_virtual/_plugin-vue_export-helper.js";
function d(e, m, f, u, g, _) {
  return i(), n("div", {
    class: c(["ap-spinner-fading-circle circle-color-" + e.id]),
    style: o({
      width: e.spinnerSize,
      height: e.spinnerSize
    })
  }, [
    (i(), n(t, null, s(12, (r) => a("div", {
      key: r,
      class: c([["is-circle" + (r + 1)], "ap-spinner-fading-circle-circle"])
    }, null, 2)), 64))
  ], 6);
}
const y = /* @__PURE__ */ p(l, [["render", d]]);
export {
  y as default
};
